import {
  APIResponse,
  UserDataOutput,
  SignUpInputData,
  UpdateUserInputData,
} from '../../@types';
import { makeAPICall } from './clientHelpers/makeAPICall';

export const authClient = {
  login: async (basicAuth: string): Promise<APIResponse<UserDataOutput>> => {
    const { notModified, data, error } = await makeAPICall({
      method: 'GET',
      url: '/user',
      basicAuth,
    });
    return {
      notModified,
      data,
      error,
    };
  },
  preLoginWithEmail: async (
    payload: any
  ): Promise<APIResponse<UserDataOutput>> => {
    const { notModified, data, error } = await makeAPICall({
      method: 'POST',
      url: '/user/preLoginWithEmail',
      data: payload,
    });
    return {
      notModified,
      data,
      error,
    };
  },
  loginWithEmail: async (
    payload: any
  ): Promise<APIResponse<UserDataOutput>> => {
    const { notModified, data, error } = await makeAPICall({
      method: 'POST',
      url: '/user/loginWithEmail',
      data: payload,
    });
    return {
      notModified,
      data,
      error,
    };
  },
  signUp: async (
    basicAuth: string,
    signUpDataInput: SignUpInputData,
    utmSource?: string,
    utmMedium?: string
  ): Promise<APIResponse<UserDataOutput>> => {
    let queryParams = '';
    if (utmSource) queryParams += `utm_source=${encodeURIComponent(utmSource)}`;
    if (utmMedium) {
      queryParams += `${queryParams ? '&' : ''}utm_medium=${encodeURIComponent(
        utmMedium
      )}`;
    }

    const url = `/user${queryParams ? `?${queryParams}` : ''}`;

    const { notModified, data, error } = await makeAPICall({
      method: 'POST',
      url,
      data: signUpDataInput,
      basicAuth,
    });
    return {
      notModified,
      data,
      error,
    };
  },
  forgetPassword: async (
    email: string,
    phone: string | null = null,
    token: string | null = null
  ): Promise<APIResponse<null>> => {
    const { error } = await makeAPICall({
      method: 'POST',
      url: '/forgot',
      data: {
        ...(email && { email }),
        ...(phone && { phoneNumber: phone }),
        ...(token && { captchaToken: token }),
      },
    });
    return {
      error,
    };
  },
  verifyPhone: async (
    phone: string | null,
    code: string,
    token: string | null = null
  ): Promise<APIResponse<null>> => {
    const { data, error } = await makeAPICall({
      method: 'PUT',
      url: '/user/verifyPhone',
      data: {
        ...(phone && { phoneNumber: phone }),
        ...(code && { verificationCode: code }),
        ...(token && { captchaToken: token }),
      },
    });
    return {
      data,
      error,
    };
  },
  resetPassword: async (
    email: string,
    password: string,
    token: string
  ): Promise<APIResponse<null>> => {
    const { error } = await makeAPICall({
      method: 'PUT',
      url: '/forgot',
      data: {
        email,
        password,
        token,
      },
    });
    return {
      error,
    };
  },
  checkReferral: async (
    updateUserInputData: UpdateUserInputData
  ): Promise<APIResponse<null>> => {
    const { error } = await makeAPICall({
      method: 'POST',
      url: '/user',
      data: updateUserInputData,
    });
    return {
      error,
    };
  },
  checkCircle: async (
    updateUserInputData: UpdateUserInputData
  ): Promise<APIResponse<null>> => {
    const { error } = await makeAPICall({
      method: 'POST',
      url: '/user',
      data: updateUserInputData,
    });
    return {
      error,
    };
  },
};
